// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__CWLtJ","navLink":"Nav_navLink__Pr8f9","ulList":"Nav_ulList__1SN7B","header":"Nav_header__D66NQ"};